"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var Pill = function Pill(_ref) {
  var _ref$newStyle = _ref.newStyle,
      newStyle = _ref$newStyle === void 0 ? false : _ref$newStyle,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? true : _ref$isValid,
      children = _ref.children;
  var baseClass = 'preact-pill';
  if (newStyle) baseClass = "".concat(baseClass, "-new");
  var classes = (0, _classnames.default)(baseClass, !isValid && 'invalid');
  return (0, _preact.h)("div", {
    className: classes
  }, children);
};

var _default = Pill;
exports.default = _default;